import GradientContainer from "@app/components/gradient/gradient-container";
import Image from "next/image";

const DesktopBeginAtStart = () => {
  return (
    <div>
      <div className="flex flex-col mt-10 space-y-5 text-center pt-10 justify-center items-center">
        <p className="subheading text-secondary-dark">
          The time to start saving is now.
        </p>
        <p className="h3 text-text-color-high-em-light">Begin at the start</p>
        <GradientContainer overrideClassName="w-[200px] h-2" />
      </div>

      <div className="flex px-32 pt-14 pb-64">
        <div className="flex space-x-10 xl:space-x-20 flex-row ">
          <div className="w-1/2 2xl:flex 2xl:justify-center">
            <Image
              src="/images/industries/begin.png"
              alt="begin"
              width={560}
              height={560}
            />
          </div>
          <div className="flex w-1/2 items-center space-y-10 flex-col justify-center">
            <div className="flex flex-col space-y-5">
              <p className="h4 xl:h3 text-text-color-high-em-light">
                Flex Options
              </p>
              <p className="text-text-color-mid-em-light">
                Sign-up with SimpleWaste and start your savings immediately. On
                our plan, your value and savings increase over time. We provide
                flexible options with terms that fit your needs.
              </p>
            </div>
            <div className="flex flex-col space-y-5">
              <p className="h4 xl:h3 text-text-color-high-em-light">
                Administrative Control
              </p>
              <p className="text-text-color-mid-em-light">
                Maintain your facility operations with SimpleWaste innovation.
                Start using the platform that enables process, service, and
                vendor administration with ease.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DesktopBeginAtStart;
